import { useContext } from 'react';
import SidebarContext from './SidebarContext';

// Export the hook to use sidebar context
export const useSidebar = () => useContext(SidebarContext);
